import Validator from "./Validator";
import ErrorHandler from "./ErrorHandler";
import Notices from "./Notices";
export default class RegistrationForm {
    constructor() {
        this.radioButtons = document.querySelectorAll('#formContainer input[type = "radio"], #formContainer input[type = "checkbox"]');
        this.checkboxButtons = document.querySelectorAll('#formContainer input[type = "checkbox"]');
        this.regFormEmail = document.querySelector("#regFormEmail");
        this.regFormPassword = document.querySelector("#regFormPassword");
        this.submitButton = document.querySelector("#regFormSubmit");
        this.essex = document.querySelector('#pegExtRegForm [name=essex]');
        this.addEventListeners();
        this.initNotices();
    }
    initNotices() {
        new Notices([
            {
                inputElement: "#regFormEmail",
                notice: "#emailNoticeBox",
            },
            {
                inputElement: "#regFormPassword",
                notice: "#passwordRestrictionInfo",
            },
        ]);
    }
    addEventListeners() {
        this.radioButtons.forEach((element) => element.addEventListener("change", (event) => this.clickRadioButton(event)));
        this.checkboxButtons.forEach((element) => element.addEventListener("click", (event) => this.clickCheckboxButton(event)));
        this.submitButton.addEventListener("click", (event) => this.clickSubmitButton(event));
        this.regFormPassword.addEventListener("keyup", (event) => Validator.checkPasswordRestrictions(event));
        this.regFormPassword.addEventListener("change", (event) => Validator.checkPasswordRestrictions(event));
        this.regFormPassword.addEventListener("focus", () => this.hidePasswordErrors());
        this.regFormEmail.addEventListener("keyup", () => this.validateEmail());
    }
    hidePasswordErrors() {
        ErrorHandler.hide("#regPasswordEmptyError");
        ErrorHandler.hide("#regPasswordNotValidError");
    }
    validateEmail() {
        if (Validator.isValidEmail()) {
            ErrorHandler.hide("#regEmailError");
        }
    }
    showAllElements() {
        const elements = document.querySelectorAll(".widget .hide");
        for (const element of elements) {
            element.classList.remove("hide");
        }
    }
    getEssexValue() {
        const essexW = document.querySelector('input[id=essexW]');
        const essexM = document.querySelector('input[id=essexM]');
        if (!essexW.checked && !essexM.checked) {
            return '';
        }
        if (essexW.checked && essexM.checked) {
            return '3';
        }
        return essexW.checked ? essexW.value : essexM.value;
    }
    clickRadioButton(event) {
        const radioElement = event.target;
        this.selectOtherGender(radioElement.name, radioElement.id);
        this.showAllElements();
        ErrorHandler.hide("#regsexError");
    }
    clickCheckboxButton(event) {
        const essexValue = this.getEssexValue();
        if (essexValue === '') {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        this.essex.value = essexValue;
    }
    clickSubmitButton(event) {
        event.preventDefault();
        event.stopPropagation();
        if (document.querySelectorAll(".widget .hide").length) {
            this.showAllElements();
            return true;
        }
        ErrorHandler.hideAll();
        let hasErrors = false;
        if (!Validator.isValidGender()) {
            ErrorHandler.show("#regsexError");
            hasErrors = true;
        }
        if (!Validator.isValidEmail()) {
            ErrorHandler.show("#regEmailError");
            hasErrors = true;
        }
        if (Validator.isPasswordEmpty()) {
            ErrorHandler.show("#regPasswordEmptyError");
            hasErrors = true;
        }
        if (!Validator.isValidPassword()) {
            ErrorHandler.show("#regPasswordNotValidError");
            hasErrors = true;
        }
        if (!hasErrors) {
            const form = document.querySelector("#formRegistration");
            form.submit();
        }
    }
    inputIsChecked() {
        return document.querySelector(`input[name = "mysex"]:checked`) && this.getEssexValue() !== '';
    }
    selectOtherGender(selectedType, selectedValue) {
        const type = selectedType === "mysex" ? "essex" : "mysex";
        if (this.inputIsChecked()) {
            return;
        }
        const myGender = selectedValue.slice(-1);
        let partnerGender = "";
        if (document.querySelector("#formContainer").classList.contains("hetero")) {
            partnerGender = myGender === "W" ? "M" : "W";
        }
        else {
            partnerGender = myGender === "W" ? "W" : "M";
        }
        const selector = `input#${type}${partnerGender}`;
        document.querySelector(selector).checked = true;
        this.essex.value = this.getEssexValue();
    }
}
